/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_Venue_HintInputs */

const cs_settings_users_venue_hint = /** @type {(inputs: Settings_Users_Venue_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Každý patří k pobočce. Pokud je jen jedna, vybere se sama.`)
};

const en_settings_users_venue_hint = /** @type {(inputs: Settings_Users_Venue_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every person belongs to a branch. If there is only one, it is selected automatically.`)
};

/**
* | output |
* | --- |
* | "Every person belongs to a branch. If there is only one, it is selected automatically." |
*
* @param {Settings_Users_Venue_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_venue_hint = /** @type {((inputs?: Settings_Users_Venue_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_Venue_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_venue_hint(inputs)
	return cs_settings_users_venue_hint(inputs)
});